<template>
  <jd-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="620px"
    append-to-body
    sureText="提交"
    :sureLoading="submitting"
    @close="handleCancel"
    @comfirm="handleSubmit"
  >
    <template #title>
      <div class="feedback-title-wrap">
        <span class="feedback-title">帮助与反馈</span>
        <span class="feedback-sub">7个工作日内回复</span>
      </div>
    </template>
    <div class="feedback-content">
      <div class="feedback-item">
        <span class="feedback-label">问题描述：</span>
        <div class="feedback-textarea-wrap">
          <el-input
            v-model="feedbackText"
            type="textarea"
            :rows="7"
            maxlength="200"
            placeholder="请输入您遇到的问题或建议"
            resize="none"
            show-word-limit
          ></el-input>
        </div>
      </div>
    </div>
  </jd-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { submitFeedback } from "@/api/ai/newAi.js";
export default {
  name: "AiFeedbackDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      feedbackText: "",
      submitting: false,
    };
  },
  computed: {
    ...mapGetters(["loginUserInfo"]),
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    handleCancel() {
      this.$emit("input", false);
    },
    handleSubmit() {
      if (!this.feedbackText) {
        this.$message.warning("请填写内容后提交");
        return;
      }
      this.submitting = true;
      submitFeedback({
        feedback: this.feedbackText,
        platformCode: "JD",
        shopName: this.loginUserInfo.shopTitle,
        companyName: this.loginUserInfo.platformAccountInfo.companyName,
        userId: this.loginUserInfo.platformAccountInfo.platformCompanyUserId,
      })
        .then((res) => {
          this.submitting = false;
          if (res.code == 200) {
            this.$message.success("提交成功");
            this.dialogVisible = false;
          }
        })
        .catch(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback-title-wrap {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.feedback-title {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}
.feedback-sub {
  font-size: 14px;
  color: #666;
}
.feedback-content {
  padding-top: 8px;
}
.feedback-item {
  display: flex;
  align-items: flex-start;
}
.feedback-label {
  font-size: 14px;
  color: #333;
  line-height: 32px;
  flex-shrink: 0;
}
.feedback-textarea-wrap {
  flex: 1;
  position: relative;
}
.feedback-count {
  position: absolute;
  right: 12px;
  bottom: 12px;
  font-size: 12px;
  color: #999;
}
.feedback-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
